import { motion } from "framer-motion";
import { Eye, FolderSearch, MessagesSquare, ShieldCheck, Clock3 } from "lucide-react";
import { SectionHead, EASE } from "./Reveal";

const BENEFICI = [
  {
    icon: Eye,
    title: "Sai che cosa succede",
    desc: "Hai una visione più chiara delle attività e delle scadenze che riguardano la tua Partita IVA.",
  },
  {
    icon: FolderSearch,
    title: "Trovi tutto più facilmente",
    desc: "Informazioni, comunicazioni e documenti non sono più dispersi tra strumenti differenti.",
  },
  {
    icon: MessagesSquare,
    title: "Ricevi risposte contestualizzate",
    desc: "Puoi confrontarti con un professionista che conosce la tua posizione.",
  },
  {
    icon: ShieldCheck,
    title: "Riduci errori e dimenticanze",
    desc: "Una gestione più organizzata ti aiuta a rispettare attività, richieste e scadenze.",
  },
  {
    icon: Clock3,
    title: "Recuperi tempo",
    desc: "Dedichi meno energie alla burocrazia e più tempo alla tua professione, ai tuoi clienti e ai tuoi progetti.",
  },
];

export default function Benefici() {
  return (
    <section
      id="benefici"
      data-testid="section-benefici"
      className="relative border-y border-white/5 bg-slate-950/40 py-24 lg:py-32"
    >
      <div className="pointer-events-none absolute right-[15%] top-[15%] h-[360px] w-[360px] rounded-full bg-[#1B6EF3]/10 blur-[120px]" />
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHead
          eyebrow="I benefici"
          align="center"
          title={
            <>
              Più controllo. <span className="text-gradient">Meno stress</span>
            </>
          }
        />

        <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {BENEFICI.map((b, i) => (
            <motion.div
              key={b.title}
              data-testid={`benefici-card-${i}`}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.65, delay: (i % 3) * 0.08, ease: EASE }}
              whileHover={{ y: -6 }}
              className={`glow-card group flex h-full flex-col gap-4 rounded-3xl p-7 ${
                i === 0 ? "lg:col-start-1" : ""
              } ${i >= 3 ? "lg:col-span-1" : ""}`}
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-2xl border border-cyan-400/25 bg-cyan-400/10 text-cyan-300 transition-all duration-300 group-hover:bg-gradient-to-br group-hover:from-[#1B6EF3] group-hover:to-[#19D6E8] group-hover:text-white">
                <b.icon className="h-5 w-5" />
              </span>
              <h3 className="font-display text-lg font-bold tracking-tight sm:text-xl">{b.title}</h3>
              <p className="text-sm leading-relaxed text-slate-400">{b.desc}</p>
            </motion.div>
          ))}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.65, delay: 0.24, ease: EASE }}
            className="flex h-full flex-col justify-center gap-3 rounded-3xl bg-gradient-to-br from-[#1B6EF3] to-[#19D6E8] p-7 shadow-xl shadow-blue-500/25"
            data-testid="benefici-cta-card"
          >
            <p className="font-display text-xl font-extrabold leading-snug text-white sm:text-2xl">
              E il tuo lavoro riprende il posto che gli spetta.
            </p>
            <p className="text-sm leading-relaxed text-white/80">
              Al centro: la tua professione, i tuoi clienti, i tuoi progetti.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
